import { withJsonFormsControlProps } from "@jsonforms/react";
import KeywordChips from "./KeywordChips";

function KeywordChipsRenderer({ data, handleChange, path, enabled }) {
  const keywords = data || [];

  const handleKeywordsChange = (newKeywords) => {
    handleChange(path, newKeywords);
  };

  return (
    <KeywordChips
      keywords={keywords}
      onChange={handleKeywordsChange}
      disabled={!enabled}
    />
  );
}

const KeywordChipsRendererWithProps =
  withJsonFormsControlProps(KeywordChipsRenderer);

export default KeywordChipsRendererWithProps;
